import { gql } from '@apollo/client';

// ===== 常量 =====

export const RULE_TYPE_BASIC = 1;
export const RULE_TYPE_REGEX = 2;
export const STATUS_DISABLED = 0;
export const STATUS_ENABLED = 1;
export const ZIP_TYPE_EXACT = 1;
export const ZIP_TYPE_RANGE = 2;

// ===== Types =====

export interface AddressWhitelistRuleType {
  id: string;
  ruleName: string;
  priority: number;
  status: number;
  addressId: number;
  fullStandardAddress: string;
  ruleType: number;
  state?: string | null;
  city?: string | null;
  zipType?: number | null;
  zipCode?: string | null;
  zipStart?: string | null;
  zipEnd?: string | null;
  streetInclude?: string | null;
  streetExclude?: string | null;
  regex?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface AddressWhitelistRulePageResponse {
  content: AddressWhitelistRuleType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetAddressWhitelistRuleListResponse {
  addressWhitelistRuleList: AddressWhitelistRulePageResponse;
}

export interface AddressWhitelistRuleInput {
  ruleName: string;
  priority: number;
  status: number;
  addressId: number;
  fullStandardAddress: string;
  ruleType: number;
  state?: string | null;
  city?: string | null;
  zipType?: number | null;
  zipCode?: string | null;
  zipStart?: string | null;
  zipEnd?: string | null;
  streetInclude?: string | null;
  streetExclude?: string | null;
  regex?: string | null;
}

export interface TestAddressWhitelistRuleInput {
  ruleType: number;
  state?: string | null;
  city?: string | null;
  zipType?: number | null;
  zipCode?: string | null;
  zipStart?: string | null;
  zipEnd?: string | null;
  streetInclude?: string | null;
  streetExclude?: string | null;
  regex?: string | null;
  testStreetAddress: string;
  testUnit?: string | null;
  testCity: string;
  testState: string;
  testZipCode: string;
}

export interface TestAddressWhitelistRuleResult {
  matched: boolean;
  fullAddress: string;
}

export interface TestAddressWhitelistRuleResponse {
  testAddressWhitelistRule: TestAddressWhitelistRuleResult;
}

// ===== 标准地址校验（复用 analyzeAddressSimple）=====

export interface AddressValidationResult {
  isValid: boolean;
  normalizedComponents?: {
    addressLine1: string;
    cityName?: string | null;
    stateAbbreviation?: string | null;
    zipcode?: string | null;
  } | null;
  entityComponents?: {
    addressLine1: string;
    addressLine2?: string;
    cityName?: string | null;
    stateAbbreviation?: string | null;
    zipcode?: string | null;
    idLog?: string | null;
  } | null;
  validationReason?: string | null;
}

export interface AnalyzeAddressSimpleResponse {
  analyzeAddressSimple?: AddressValidationResult | null;
}

export const ANALYZE_ADDRESS_SIMPLE = gql`
  query RuleAnalyzeAddressSimple(
    $streetAddress: String!
    $unit: String
    $city: String!
    $state: String!
    $zipCode: String!
    $forceExternalApiMatch: Boolean
  ) {
    analyzeAddressSimple(
      streetAddress: $streetAddress
      unit: $unit
      city: $city
      state: $state
      zipCode: $zipCode
      forceExternalApiMatch: $forceExternalApiMatch
    ) {
      isValid
      validationReason
      normalizedComponents {
        addressLine1
        addressLine2
        cityName
        stateAbbreviation
        zipcode
      }
      entityComponents {
        addressLine1
        addressLine2
        cityName
        stateAbbreviation
        zipcode
        idLog
      }
    }
  }
`;

// ===== Query =====

export const GET_ADDRESS_WHITELIST_RULE_LIST = gql`
  query GetAddressWhitelistRuleList(
    $ruleName: String
    $ruleType: Int
    $status: Int
    $state: String
    $city: String
    $page: Int!
    $size: Int!
  ) {
    addressWhitelistRuleList(
      ruleName: $ruleName
      ruleType: $ruleType
      status: $status
      state: $state
      city: $city
      page: $page
      size: $size
    ) {
      content {
        id
        ruleName
        priority
        status
        addressId
        fullStandardAddress
        ruleType
        state
        city
        zipType
        zipCode
        zipStart
        zipEnd
        streetInclude
        streetExclude
        regex
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const TEST_ADDRESS_WHITELIST_RULE = gql`
  query TestAddressWhitelistRule($input: TestAddressWhitelistRuleInput!) {
    testAddressWhitelistRule(input: $input) {
      matched
      fullAddress
    }
  }
`;

// ===== Mutations =====

export const CREATE_ADDRESS_WHITELIST_RULE = gql`
  mutation CreateAddressWhitelistRule($input: CreateAddressWhitelistRuleInput!) {
    createAddressWhitelistRule(input: $input) {
      id
      ruleName
    }
  }
`;

export const UPDATE_ADDRESS_WHITELIST_RULE = gql`
  mutation UpdateAddressWhitelistRule($id: Long!, $input: UpdateAddressWhitelistRuleInput!) {
    updateAddressWhitelistRule(id: $id, input: $input) {
      id
      ruleName
    }
  }
`;

export const UPDATE_ADDRESS_WHITELIST_RULE_STATUS = gql`
  mutation UpdateAddressWhitelistRuleStatus($id: Long!, $status: Int!) {
    updateAddressWhitelistRuleStatus(id: $id, status: $status)
  }
`;

export const DELETE_ADDRESS_WHITELIST_RULE = gql`
  mutation DeleteAddressWhitelistRule($id: Long!) {
    deleteAddressWhitelistRule(id: $id)
  }
`;
